import MessagesReducer, { fetchMessagesEpic } from './Messages'
import DtcsReducer, { fetchDtcsEpic } from './Dtcs'
import CanLoggerMessagesReducer, { fetchCanLoggerMessagesEpic } from './CanLoggerMessages'
import SignalLoggerSignalsReducer, { fetchSignalLoggerSignalsEpic } from './SignalLoggerSignals'

export const epics = [
  fetchMessagesEpic,
  fetchDtcsEpic,
  fetchCanLoggerMessagesEpic,
  fetchSignalLoggerSignalsEpic,
]

export default {
  messages: MessagesReducer,
  dtcs: DtcsReducer,
  canLoggerMessages: CanLoggerMessagesReducer,
  signalLoggerSignals: SignalLoggerSignalsReducer,
}
